import { PaginationI } from './pagination.interface';
import { ContentLocalesI } from './session.types';

export enum ScaleVisualization {
  Stars = 'stars',
  Nps = 'nps',
  Labels = 'labels',
  Respondents = 'respondents',
  McqOptions = 'options',
}

export type ScaleFilterTypes = 'all' | ScaleVisualization;

export enum ScaleType {
  Ordinal = 'ordinal',
  Categorial = 'categorial',
}

export enum ScaleScope {
  Admin = 'admin',
  ScaleUserTopicFixedScope = 'user-topic-fixed-scale',
}

export interface Scale {
  id: string;
  name: ContentLocalesI;
  description: ContentLocalesI;
  visualization: ScaleVisualization;
  labels: ContentLocalesI[];
  multipleChoiceOptions: ContentLocalesI[];
  isMultipleChoiceEnabled: boolean;
  scope: ScaleScope;
  type: ScaleType;
  denominator: number; // i.e. scale length minus one
  versionId: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

export function getScaleLabels(scale: Scale): ContentLocalesI[] {
  return (scale.visualization === ScaleVisualization.McqOptions ? scale.multipleChoiceOptions : scale.labels) || [];
}

export interface ScalesRespI {
  pagination: PaginationI;
  items: Scale[];
  scales_distribution: { [key in ScaleVisualization]: number };
  sorting: unknown;
  filters: unknown;
}

export interface FetchScalesParams {
  include?: string;
  page?: number;
  per_page?: number;
  'filter.visualization'?: ScaleFilterTypes;
  sort?: ScalesSortParam;
}

export enum ScalesSortParam {
  CreatedAsc = 'created',
  CreatedDesc = '-created',
}

export enum ScaleIncludeParam {
  ScaleDeleted = 'scale.deleted',
  ScaleVersion = 'scale.versions',
  ScaleCustom = 'scale.custom',
}
